/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  updateIceBreakers(inboxId, iceBreakers) {
    return axios.put(`${this.url}/inboxes/${inboxId}/ice_breakers`, {
      ice_breakers: iceBreakers,
    });
  }
}

export default new InstagramChannel();
